import { Link, useLocation } from "react-router-dom";

function ParentsQuickNav() {
  const location = useLocation();

  const categories = [
    { name: "🛏️ Gear", path: "/parents/nursery-gear", color: "emerald" },
    { name: "🍼 Daily", path: "/parents/daily-must-haves", color: "green" }
  ];

  return (
    <div className="sticky top-20 z-40 bg-gradient-to-b from-green-50 to-emerald-50 py-4 mb-12 -mx-6 px-6 md:mx-0 md:px-0 shadow-md">
      <div className="flex flex-wrap justify-center gap-4">
        {categories.map((category) => {
          const isActive = location.pathname === category.path;
          const bgColor = category.color === "emerald" 
            ? "bg-emerald-400 hover:bg-emerald-500" 
            : "bg-green-400 hover:bg-green-500";
          const activeClass = isActive ? "ring-4 ring-emerald-600 scale-105" : "";
          
          return (
            <Link
              key={category.path}
              to={category.path}
              className={`${bgColor} ${activeClass} text-white font-black text-lg md:text-xl px-8 py-4 rounded-3xl shadow-xl transform transition-all duration-300 hover:scale-110 hover:-rotate-1 active:scale-95`}
              style={{ fontFamily: "'Chalkboard SE', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" }}
            >
              {category.name}
            </Link>
          );
        })}
      </div>
    </div>
  );
}

export default ParentsQuickNav;
